import { composeFieldPath } from '@northfork/basics'

export interface SleeveDetails {
  id: string
  name: string
  accountType: string
}

export interface AggregateDetails {
  id: string
  name: string
}

export const SleeveDetailsField = composeFieldPath([] as SleeveDetails[])
export const AggregateDetailsField = composeFieldPath([] as AggregateDetails[])
